import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridOptions } from 'ag-grid-community';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { IPagedResults } from '../../../core/interfaces';
import { SiteService } from '../../../services';
import { SitesEditComponent } from '../../../components/sites/sites-edit.component';
import { modalLarge, modalSmall } from '../../modules/dialogOptions';

@Component({
    selector: 'app-sites-list',
    templateUrl: './sites-list.component.html',
    styleUrls: ['../../../components/layout/layout.component.scss']
})
export class SitesListComponent implements OnInit {
    dataToDelete: any;
    @Output() siteEditView = new EventEmitter();
    @Output() DeleteObjectEventData = new EventEmitter();
    public showSpinner: boolean = false;
    public itemPerPage: number = 100;
    public currentPage: number = 1;
    public totalItems: number = 10;
    public isAdminOrUserEditor = false;
    public isSuperAdmin = false;
    public isAdmin = false;
    public accountId = 0;
    public filterActive: any = "1";
    objectConfirm: string = "";
    gridOptions: GridOptions;
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private siteService: SiteService,
        private modalService: NgbModal) { }

    packageData: any[];
    packageDataBack: any[];
    private gridApi;
    private gridColumnApi;
    onGridReady(params) {

        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

    }
    public overlayLoadingTemplate = '<span class="ag-overlay-loading-center"><i style="font-size: 20px;" class="fa fa-spinner fa-spin"><i></span>';

    public customCellRendererFuncTitle(params) {

        var eDiv = document.createElement('div');
        eDiv.innerHTML = "<span style='text-decoration:underline; cursor: pointer;'>" + params.data.Name + "</span>";
        return eDiv;
    };


    columnDefs = [
        // {
        //     headerName: '',width: 40 ,cellRenderer: this.customCellRendererFuncAction, filter : false
        // },
        {
            headerName: 'Name', field: 'Name',
            sortable: true, resizable: true,
            width: 160,
            sort: "asc",
            valueGetter: function(params) {
                return params.data.Name;
            },
            //comparator: this.strCompare,
            cellRenderer: this.customCellRendererFuncTitle,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'Address', field: 'Address', sortable: true, resizable: true,
            width: 190,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        {
            headerName: 'City', field: 'City', sortable: true, resizable: true,
            width: 120,
            filter: "agTextColumnFilter",
            filterParams: {
                clearButton: true,
                applyButton: true,
                debounceMs: 200
            }
        },
        // {
        //     headerName: 'Phone', field: 'Phone', sortable: true, resizable: true,
        //     width: 160,
        //     filter: "agTextColumnFilter",
        //     filterParams: {
        //         clearButton: true,
        //         applyButton: true,
        //         debounceMs: 200
        //     }           
        // },
        // {
        //     headerName: 'Contact Person', field: 'ContactPerson', sortable: true, resizable: true,
        //     width: 160,
        //     filter: "agTextColumnFilter",
        //     filterParams: {
        //         clearButton: true,
        //         applyButton: true,
        //         debounceMs: 200
        //     }           
        // },
    ];

    onRowClicked(params) {
        if (params.colDef.headerName == "") {

        }
        else {
            params.context.componentParent.editSite(params.data.Id);
        }

    }
    public ngOnInit() {
        if (this.isSuperAdmin) {
            this.filterActive = "1";
            this.loadData();
        }

        this.gridOptions = <GridOptions>{
            context: {
                componentParent: this
            },
            defaultColDef: {
                filter: true // set filtering on for all cols
            },

        };
    }

    public loadData(page?: number, id?: number) {
        this.accountId = id
        this.filterActive = "1";
        this.showSpinner = true;
        let filter = '';
        if (page != null) {
            this.currentPage = page;
        }
        if (id > 0) {
            this.loadDataById(id);
        }
        else {
            this.siteService.getSitesList(this.currentPage, this.itemPerPage, filter)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.showSpinner = false;
                    }, 1000);
                })
                .subscribe((response: IPagedResults<any>) => {

                    this.packageData = response.Data;
                    this.packageDataBack = response.Data;
                    this.totalItems = response.Data.length;
                    this.filterChange();
                });
        }

    }

    filterChange() {

        switch (this.filterActive) {
            case "0":
                this.packageData = this.packageDataBack;
                break;
            case "1":
                this.packageData = this.packageDataBack.filter(x => x.IsActive);
                break;
            case "2":
                this.packageData = this.packageDataBack.filter(x => !x.IsActive);
                break;
        }
    }

    public loadDataById(id: number) {
        this.showSpinner = true;
        this.siteService.getSitesByAccountList(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: IPagedResults<any>) => {

                this.packageData = response.Data;
                this.packageDataBack = response.Data;
                this.totalItems = response.Data.length;
                this.filterChange();
            });
    }

    public editSite(id: number) {
        //this.siteEditView.emit(id);
        var selectedRows = this.gridApi.getSelectedRows();
        const modalRef = this.modalService.open(SitesEditComponent, modalLarge);

        //localStorage.setItem('selectedRowUser', id.toString());

        modalRef.componentInstance.siteId = id.toString();
        modalRef.result.then(
            (result) => {
                this.gridApi.showLoadingOverlay()
                this.loadDataById(this.accountId)
            },
            (reason) => {
            }
        );

    }

    public openDelete(title: string, data: any) {
        this.objectConfirm = "";
        this.dataToDelete = data;
        console.log(this.dataToDelete);
        this.modalService.open(title, modalSmall);
    }
    public deleteObject(model: any) {
        this.siteService.deleteSite(model)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response: any) => {
                this.DeleteObjectEventData.emit();
            });
    }

    public editAccountSite(id: number) {
        if (this.isSuperAdmin) {
            this.router.navigate([`accounts/${id}/edit/objects`]);
        }
    } f
}



// WEBPACK FOOTER //
// ./src/app/shared/components/sites-list/sites-list.component.ts